// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oNVF","placeholdersHeader":"styles_placeholdersHeader__3zJGI","editorStyle":"styles_editorStyle__SwbdF","placeholdersBox":"styles_placeholdersBox__Vl2CZ"};